"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "pessano-con-bornago": {
    "16a5377b": [{
      "hkey": "049f6c3c",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "bornago": [{
      "hkey": "049f6c3c",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "fff0d5ee": [{
      "hkey": "8947f35c",
      "slug": "pessano-con-bornago",
      "name": "Pessano con Bornago",
      "primary": true,
      "skipSearch": false
    }],
    "bragosa": [{
      "hkey": "8947f35c",
      "slug": "pessano-con-bornago",
      "name": "Pessano con Bornago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "41eff04e": [{
      "hkey": "8947f35c",
      "slug": "pessano-con-bornago",
      "name": "Pessano con Bornago",
      "primary": true,
      "skipSearch": false
    }],
    "carozzi": [{
      "hkey": "8947f35c",
      "slug": "pessano-con-bornago",
      "name": "Pessano con Bornago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "02948390": [{
      "hkey": "049f6c3c",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "nuclei-storici-originari-pessano": [{
      "hkey": "049f6c3c",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pessano-con-bornago"
    }],
    "78bf33de": [{
      "hkey": "049f6c3c",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "oltrona": [{
      "hkey": "049f6c3c",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pessano-con-bornago"
    }],
    "4f3e72b2": [{
      "hkey": "049f6c3c",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "pariana": [{
      "hkey": "049f6c3c",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pessano-con-bornago"
    }],
    "8625b877": [{
      "hkey": "8947f35c",
      "slug": "pessano-con-bornago",
      "name": "Pessano con Bornago",
      "primary": true,
      "skipSearch": false
    }],
    "ruscona": [{
      "hkey": "8947f35c",
      "slug": "pessano-con-bornago",
      "name": "Pessano con Bornago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;